import type { Coin } from '@/lib/api/transaction/models';

/** POL / MATIC carry the token's own name on the wire; the UI calls the coin "Polygon". */
export function coinDisplayName({ shortName, name }: Pick<Coin, 'shortName' | 'name'>): string {
  const symbol = shortName.toUpperCase();
  return symbol === 'POL' || symbol === 'MATIC' ? 'Polygon' : name;
}
